import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const CLASSES = [
  {
    id: "class-card-formula500",
    name: "Formula 500s",
    desc: "High-revving 600cc winged rocketships with extreme power-to-weight speed.",
    img: "https://primary.jwwb.nl/public/o/r/n/temp-bkcxxqajnapgmncxuwyd/500-standard-ibxryc.jpg",
    span: "lg:col-span-7",
  },
  {
    id: "class-card-wingless",
    name: "Wingless Sprints",
    desc: "Pure driver skill — lightweight V6 sprint cars sliding sideways on the cushion.",
    img: "https://primary.jwwb.nl/public/o/r/n/temp-bkcxxqajnapgmncxuwyd/20251130_095803-standard.jpg",
    span: "lg:col-span-5",
  },
  {
    id: "class-card-streetstock",
    name: "Street Stocks",
    desc: "6-cylinder production cars built tough for door-to-door bumper battles.",
    img: "https://primary.jwwb.nl/public/o/r/n/temp-bkcxxqajnapgmncxuwyd/streetie-standard-nv2a91.jpg",
    span: "lg:col-span-4",
  },
  {
    id: "class-card-superrod",
    name: "Super Rods",
    desc: "Custom V8 vintage-body hot rods built for roar and high-speed oval drift.",
    img: "https://primary.jwwb.nl/public/o/r/n/temp-bkcxxqajnapgmncxuwyd/rod-standard-x97w29.jpg",
    span: "lg:col-span-4",
  },
  {
    id: "class-card-juniorkart",
    name: "Junior Quarter Midgets / JQMV",
    desc: "The 110m infield track — incubator for Australia's next champion dirt racers.",
    img: "https://primary.jwwb.nl/public/o/r/n/temp-bkcxxqajnapgmncxuwyd/555653199_24707270272259515_5224819840527179541_n-standard-dmvkql.jpg",
    span: "lg:col-span-4",
  },
];

export default function Classes() {
  return (
    <section id="classes" className="max-w-[1400px] mx-auto px-4 sm:px-8 py-20 lg:py-28">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        className="font-mono text-xs uppercase tracking-[0.35em] text-clay-orange mb-4"
      >
        Experience the Thrill of Variety
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ delay: 0.1 }}
        className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-5xl lg:text-6xl leading-none mb-14"
      >
        Racing Classes
      </motion.h2>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        {CLASSES.map((c, i) => (
          <motion.div
            key={c.id}
            data-testid={c.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative border border-clay-border bg-clay-card overflow-hidden hover:border-clay-orange/60 transition-colors duration-500 min-h-[260px] flex flex-col justify-end ${c.span}`}
          >
            {c.img && (
              <>
                <img
                  src={c.img}
                  alt={c.name}
                  className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-clay-bg via-clay-bg/60 to-transparent" />
              </>
            )}
            <div className="relative z-10 p-6 sm:p-8">
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-display font-bold uppercase text-2xl sm:text-3xl tracking-tight group-hover:text-clay-gold transition-colors duration-300">
                  {c.name}
                </h3>
                <ArrowUpRight className="w-6 h-6 text-clay-muted group-hover:text-clay-orange group-hover:rotate-45 transition-all duration-300 shrink-0" />
              </div>
              <p className="text-clay-muted text-sm leading-relaxed mt-3 max-w-md">{c.desc}</p>
            </div>
            <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-clay-orange group-hover:w-full transition-all duration-500" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
